import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as SearchBooksetsActions from 'rebook/apps/search/actions/SearchBooksetsActions';
import DashboardBookList from 'rebook/apps/dashboard/components/DashboardBookList';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BackLink from 'rebook/apps/base/components/BackLink';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import SearchResultEmpty from 'rebook/apps/search/components/SearchResultEmpty';
import pluralize from 'rebook/apps/utils/text/pluralize';
import capitalize from 'rebook/apps/utils/text/capitalize';

import styles from './style.scss';


class SearchBooksetsView extends React.Component {
  componentDidMount() {
    this.props.SearchBooksetsActions.fetchInitialData(this.props.location);
  }

  componentWillUnmount() {
    this.props.SearchBooksetsActions.resetData();
  }

  changePage(newPageNumber) {
    this.props.SearchBooksetsActions.fetchBooksets(newPageNumber);
  }

  render() {
    const {
      booksetList, booksetsCount, query, pageNumber, lastPageNumber, isLoading,
    } = this.props.searchBooksets;

    if (isLoading) {
      return (
        <div className="backgroundContainer themeGrey">
          <div className="section">
            <SpinnerLoader />
          </div>
        </div>
      );
    }
    return booksetList && booksetList.length > 0
      ? (
        <div className="backgroundContainer themeGrey">
          <div className="section">
            <BackLink link={`/search/?q=${query}`} extraClassName={styles.breadCrumbs}>
              <span className="link">Все результаты</span>
            </BackLink>
            <div className="title-1">
              Все подборки по запросу «{query}»
            </div>
            <small>
              {booksetsCount} {pluralize(booksetsCount, 'подборка', 'подборки', 'подборок')}
            </small>
            {booksetList.map((bookset) => (
              <div className={styles.bookset} key={bookset.id}>
                <DashboardBookList
                  picture={bookset.preview}
                  pictureName={bookset.name}
                  title={capitalize(bookset.name)}
                  books={bookset.books}
                  bookCount={bookset.active_book_count}
                  linkMore={bookset.absolute_url} />
              </div>
            ))}
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          </div>
        </div>
      )
      : (
        <SearchResultEmpty />
      );
  }
}

function mapStateToProps(state) {
  return {
    searchBooksets: state.searchBooksets,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SearchBooksetsActions: bindActionCreators(SearchBooksetsActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBooksetsView);
